import styled, { createGlobalStyle } from "styled-components";

export const ForgotPassGlobalStyles = createGlobalStyle`
body{
    p.modal-primarytext{
      white-space: pre-wrap;
    }
}
`
export const StyledAuthSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  &.tma_auth_content {
    padding: 0 1rem;
  }
  &.tma_login_form_wrapper {
    padding: 1rem;
    .tma_logo_container {
    }
    .tma_login_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .tma_form_info_links {
      margin: 1rem auto;
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      a {
        text-decoration: none;
        color: var(--energy);
        span {
          margin-left: 0.25rem;
          pointer-events: none;
          &.tma_link_label {
            color: var(--label-text);
          }
        }
      }
    }
  }
  &.tma_changepass_content {
    width: auto;
    height: auto;
    min-height: unset;
    h1.tma_form_title {
      font-size: 22px;
    }
    .tma_form_action {
      button {
        background-color: var(--primary-text);
        width: 100%;
      }
    }
    .tma_form_control {
      label {
        font-size: 14px;
      }
      margin-bottom: 1rem;
    }
  }

  h1.tma_form_title {
    font-size: 28px;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    text-align: left;
  }
  form.tma_auth_form {
    width: 100%;
    .tma__input_container {
      width: 100%;
      margin-bottom: 0.75rem;
      .tma__input_field {
        width: 100%;
      }
    }
    .tma_form_control.tma_form_error {
      .tma__input_container {
        .tma__input_field {
          fieldset {
            border: 1px solid red !important;
          }
        }
      }
      p.tma_error {
        margin: 0.5rem auto;
      }
    }
    .tma_form_helper_text {
      margin: 1rem auto;
    }
    .tma_form_switcher {
      margin-bottom: 1rem;
      a {
        text-decoration: none;
        font-size: large;
        color: #0040ff;
        font-weight: bold;
      }
    }
    .tma_form-feedback {
      margin: 1rem auto;
      p.tma_error {
        color: red;
      }
    }
    .MuiOutlinedInput-root {
      font-size: 14px;
      height: 38px;
      &.Mui-disabled {
        background-color: #ccc;
      }
    }
  }
  p.MuiFormHelperText-root {
    margin-left: 0;
  }
  .tma_restPass_form {
    .tma_form_control {
      label {
        font-size: 12px;
      }
    }
    .secretPin {
      svg {
        height: 18px;
        width: 18px;
      }
    }
  }
`;
export const StyledPasswordResetContent = styled.div`
h1{
    font-size:22px;
    white-space:nowrap;
    color:green;
}
p{
     font-size:14px;
}
p.main-content{
   
    margin:1rem auto;
}
`;

export const StyledForm = styled.form`
    width: 100%;
    max-width: 480px;
    .tma_form_control {
        padding-bottom: 10px;
        position: relative;
    }
    .tma_form_info_links {
        margin-top: 0px !important;
        font-size: 13px;
    }
`

export const StyledForgotpassword = styled.div`
    position: absolute;
    right: 0;
    margin: 0;
    z-index: 1;
    top: 43px;
    font-size: 13px;
    @media (max-width: 480px) {
        position: static;
        padding: 10px 0 0 4px;
    }
    a {
    color: #de2021;
    }
`

export const StyledLoginButton = styled.div`
    width: 100%;
    button {
        width: 100%;
        span.tma_btn_text, span.tma_btn_custom_icon {margin: 0;}
        background-color: var(--primary-text);
    }
`

export const StyledLogo = styled.img`
    width: 480px;
    height: 105px;  
    @media (max-width: 540px) {
        width: 240px;
        height: 52px; 
    }
`

export const StyledBacktoLogin = styled.div`
    display: flex;
    align-items: center;
    padding-top: 10px;
    a {
     fonr-size: 13px;
     color: var(--page-headings-text);
     padding-left: 5px;
    }
     svg {
        width: 15px;
        height: 15px;
        fill: var(--page-headings-text);
     }
`